import * as React from "react";
import { useLazyLoadImage } from "@/Utilities";
import { SvgImagePattern, SvgShadowFilter } from "./SvgTemplateDefs";

function MediumTemplateSVG({ src, id, ...props }) {

  const uniqueId = 'hf_' + id;
  const imageRef = useLazyLoadImage(src);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return (
    <svg
      width="100%"
      height="360"
      viewBox="0 0 466 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g filter={`url(#filter0_d_${uniqueId})`}>
        <g clipPath={`url(#clip0_${uniqueId})`}>
          <rect
            x={30.9768}
            y={32.9758}
            width={404.046}
            height={263.836}
            rx={3.61832}
            fill="white"
          />
          <path
            d="M41.8347 44.1332H46.6592"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.8347 46.2441H46.6592"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.8347 48.3547H46.6592"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M60.3735 47.9019L61.7304 49.2588"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.1279 45.9428C61.1279 44.444 59.913 43.229 58.4142 43.229C56.9154 43.229 55.7004 44.444 55.7004 45.9428C55.7004 47.4415 56.9154 48.6565 58.4142 48.6565C59.913 48.6565 61.1279 47.4415 61.1279 45.9428Z"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinejoin="round"
          />
          <path
            d="M224.983 49.197V43.2007H225.925V48.3404H227.476V49.197H224.983Z"
            fill="#1D1D1D"
          />
          <path
            d="M223.584 43.2003L224.543 49.1966H223.592L223.429 48.1087H222.273L222.11 49.1966H221.245L222.205 43.2003H223.584ZM222.847 44.2625L222.393 47.2949H223.301L222.847 44.2625Z"
            fill="#1D1D1D"
          />
          <path
            d="M220.031 46.9618H220.922V47.7585C220.922 48.7179 220.442 49.2661 219.517 49.2661C218.592 49.2661 218.112 48.7179 218.112 47.7585V44.6404C218.112 43.6809 218.592 43.1327 219.517 43.1327C220.442 43.1327 220.922 43.6809 220.922 44.6404V45.2229H220.031V44.5804C220.031 44.1521 219.842 43.9893 219.542 43.9893C219.243 43.9893 219.054 44.1521 219.054 44.5804V47.8184C219.054 48.2467 219.243 48.4009 219.542 48.4009C219.842 48.4009 220.031 48.2467 220.031 47.8184V46.9618Z"
            fill="#1D1D1D"
          />
          <path
            d="M215.655 44.5804V47.8184C215.655 48.2467 215.844 48.4095 216.144 48.4095C216.444 48.4095 216.632 48.2467 216.632 47.8184V44.5804C216.632 44.1521 216.444 43.9893 216.144 43.9893C215.844 43.9893 215.655 44.1521 215.655 44.5804ZM214.713 47.7585V44.6404C214.713 43.6809 215.219 43.1327 216.144 43.1327C217.069 43.1327 217.574 43.6809 217.574 44.6404V47.7585C217.574 48.7179 217.069 49.2661 216.144 49.2661C215.219 49.2661 214.713 48.7179 214.713 47.7585Z"
            fill="#1D1D1D"
          />
          <path
            d="M211.89 49.1976V43.2013H212.832V48.341H214.382V49.1976H211.89Z"
            fill="#1D1D1D"
          />
          <path
            d="M249.43 45.3428C249.43 44.7749 249.709 44.4504 250.252 44.4504C250.794 44.4504 251.073 44.7749 251.073 45.3428V45.4544H250.546V45.3073C250.546 45.0538 250.445 44.9575 250.267 44.9575C250.09 44.9575 249.988 45.0538 249.988 45.3073C249.988 46.0375 251.078 46.1744 251.078 47.1885C251.078 47.7564 250.794 48.081 250.247 48.081C249.699 48.081 249.415 47.7564 249.415 47.1885V46.9705H249.943V47.224C249.943 47.4776 250.054 47.5688 250.232 47.5688C250.409 47.5688 250.521 47.4776 250.521 47.224C250.521 46.4939 249.43 46.357 249.43 45.3428Z"
            fill="#1D1D1D"
          />
          <path
            d="M244.592 47.9998L244.389 46.1085L244.187 47.9998H243.421L243.025 44.4504H243.568L243.867 47.2494L244.136 44.4504H244.673L244.952 47.2697L245.241 44.4504H245.728L245.333 47.9998H244.592Z"
            fill="#1D1D1D"
          />
          <path
            d="M238.109 44.9578V45.9466H238.874V46.4536H238.109V47.4931H239.072V48.0002H237.551V44.4507H239.072V44.9578H238.109Z"
            fill="#1D1D1D"
          />
          <path
            d="M232.764 48.0002L232.069 45.4294V48.0002H231.567V44.4507H232.267L232.84 46.5753V44.4507H233.337V48.0002H232.764Z"
            fill="#1D1D1D"
          />
          <path
            d="M250.865 42.6255H248.03H246.931H241.892H240.793H235.759H234.656H231.825C230.004 42.6255 228.522 44.1072 228.522 45.9282V46.5594C228.522 48.3804 230.004 49.8621 231.825 49.8621H234.656H235.759H240.794H241.892H246.932H248.03H250.866C252.687 49.8621 254.168 48.3804 254.168 46.5594V45.9282C254.168 44.1071 252.687 42.6255 250.865 42.6255ZM234.656 48.7588H231.825C230.612 48.7588 229.625 47.7722 229.625 46.5592V45.928C229.625 44.7151 230.612 43.7285 231.825 43.7285H234.656V48.7588ZM240.789 48.7588H235.759V43.7287H240.789V48.7588ZM246.927 48.7588H241.897V43.7287H246.927V48.7588ZM253.065 46.5592C253.065 47.7722 252.078 48.7588 250.865 48.7588H248.035V43.7287H250.865C252.078 43.7287 253.065 44.7153 253.065 45.9282V46.5592Z"
            fill="#1D1D1D"
          />
          <path
            d="M420.118 47.2934C419.691 47.5474 418.572 48.066 419.254 48.7151C419.586 49.0321 419.957 49.2588 420.423 49.2588H423.082C423.548 49.2588 423.919 49.0321 424.251 48.7151C424.933 48.066 423.814 47.5474 423.388 47.2934C422.387 46.6977 421.118 46.6977 420.118 47.2934Z"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M423.115 44.5849C423.115 45.3343 422.508 45.9418 421.758 45.9418C421.009 45.9418 420.402 45.3343 420.402 44.5849C420.402 43.8355 421.009 43.228 421.758 43.228C422.508 43.228 423.115 43.8355 423.115 44.5849Z"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
          />
          <rect
            x={43.0391}
            y={59.511}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0393}
            y={72.1752}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0393}
            y={84.8394}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0393}
            y={97.5035}
            width={190.565}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={192.183}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={204.847}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={217.511}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={230.175}
            width={150.763}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={254.9}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={267.564}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={280.229}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={292.893}
            width={150.763}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={287.277}
            y={205.149}
            width={135.687}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={287.277}
            y={217.813}
            width={135.687}
            height={24.1222}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={287.277}
            y={245.553}
            width={135.687}
            height={24.1222}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={287.277}
            y={273.294}
            width={135.687}
            height={24.1222}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0391}
            y={122.229}
            width={74.9797}
            height={54.2749}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={121.637}
            y={122.229}
            width={74.9797}
            height={54.2749}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={200.235}
            y={122.229}
            width={74.9797}
            height={54.2749}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <g clipPath={`url(#clip1_${uniqueId})`}>
            <rect
              x={287.276}
              y={76.3962}
              width={135.687}
              height={113.073}
              fill={`url(#pattern0_${uniqueId})`}
            />
          </g>
          <rect
            x={287.277}
            y={59.511}
            width={135.687}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
        </g>
      </g>
      <g filter={`url(#filter1_d_${uniqueId})`}>
        <g clipPath={`url(#clip2_${uniqueId})`}>
          <rect
            x={63.3005}
            y={156.883}
            width={107.476}
            height={232.461}
            rx={3.23237}
            fill="white"
          />
          <g clipPath={`url(#clip3_${uniqueId})`}>
            <rect
              x={63.0308}
              y={208.871}
              width={107.476}
              height={89.4289}
              fill={`url(#pattern1_${uniqueId})`}
            />
            <rect
              x={70.0342}
              y={186.967}
              width={94.0081}
              height={8.08092}
              rx={1.86915}
              fill="#F0F0F0"
            />
            <rect
              x={70.0342}
              y={315.097}
              width={94.0081}
              height={8.08092}
              rx={1.07746}
              fill="#F0F0F0"
            />
            <rect
              x={70.0342}
              y={325.333}
              width={94.0081}
              height={8.08092}
              rx={1.07746}
              fill="#F0F0F0"
            />
            <rect
              x={70.0342}
              y={335.569}
              width={94.0081}
              height={8.08092}
              rx={1.07746}
              fill="#F0F0F0"
            />
            <rect
              x={70.0342}
              y={345.805}
              width={94.0081}
              height={8.08092}
              rx={1.07746}
              fill="#F0F0F0"
            />
            <rect
              x={70.0342}
              y={356.04}
              width={94.0081}
              height={8.08092}
              rx={1.07746}
              fill="#F0F0F0"
            />
            <rect
              x={70.0342}
              y={366.276}
              width={73.2671}
              height={8.08092}
              rx={1.07746}
              fill="#F0F0F0"
            />
            <path
              d="M70.7764 174.179H75.7608"
              stroke="#1D1D1D"
              strokeWidth={0.623051}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M70.7764 176.359H75.7608"
              stroke="#1D1D1D"
              strokeWidth={0.623051}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M70.7764 178.54H75.7608"
              stroke="#1D1D1D"
              strokeWidth={0.623051}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M110.087 178.278V173.116H110.898V177.541H112.233V178.278H110.087Z"
              fill="#1D1D1D"
            />
            <path
              d="M108.883 173.116L109.709 178.278H108.891L108.751 177.342H107.755L107.615 178.278H106.87L107.696 173.116H108.883ZM108.249 174.03L107.858 176.641H108.64L108.249 174.03Z"
              fill="#1D1D1D"
            />
            <path
              d="M105.824 176.354H106.591V177.04C106.591 177.866 106.178 178.338 105.382 178.338C104.585 178.338 104.172 177.866 104.172 177.04V174.355C104.172 173.529 104.585 173.057 105.382 173.057C106.178 173.057 106.591 173.529 106.591 174.355V174.857H105.824V174.304C105.824 173.935 105.662 173.795 105.404 173.795C105.146 173.795 104.983 173.935 104.983 174.304V177.091C104.983 177.46 105.146 177.593 105.404 177.593C105.662 177.593 105.824 177.46 105.824 177.091V176.354Z"
              fill="#1D1D1D"
            />
            <path
              d="M102.06 174.304V177.091C102.06 177.46 102.222 177.6 102.48 177.6C102.738 177.6 102.9 177.46 102.9 177.091V174.304C102.9 173.935 102.738 173.795 102.48 173.795C102.222 173.795 102.06 173.935 102.06 174.304ZM101.248 177.04V174.355C101.248 173.529 101.683 173.057 102.48 173.057C103.276 173.057 103.712 173.529 103.712 174.355V177.04C103.712 177.866 103.276 178.338 102.48 178.338C101.683 178.338 101.248 177.866 101.248 177.04Z"
              fill="#1D1D1D"
            />
            <path
              d="M98.8154 178.278V173.116H99.6267V177.541H100.962V178.278H98.8154Z"
              fill="#1D1D1D"
            />
            <path
              d="M131.134 174.96C131.134 174.471 131.374 174.192 131.841 174.192C132.308 174.192 132.548 174.471 132.548 174.96V175.056H132.094V174.93C132.094 174.712 132.007 174.629 131.854 174.629C131.701 174.629 131.614 174.712 131.614 174.93C131.614 175.559 132.553 175.676 132.553 176.55C132.553 177.038 132.308 177.318 131.837 177.318C131.365 177.318 131.121 177.038 131.121 176.55V176.362H131.575V176.58C131.575 176.798 131.671 176.877 131.823 176.877C131.976 176.877 132.072 176.798 132.072 176.58C132.072 175.951 131.134 175.834 131.134 174.96Z"
              fill="#1D1D1D"
            />
            <path
              d="M126.97 177.248L126.795 175.62L126.62 177.248H125.961L125.621 174.192H126.088L126.345 176.602L126.577 174.192H127.039L127.28 176.619L127.528 174.192H127.947L127.607 177.248H126.97Z"
              fill="#1D1D1D"
            />
            <path
              d="M121.385 174.629V175.48H122.044V175.917H121.385V176.811H122.214V177.248H120.905V174.192H122.214V174.629H121.385Z"
              fill="#1D1D1D"
            />
            <path
              d="M116.784 177.248L116.186 175.035V177.248H115.754V174.192H116.357L116.85 176.021V174.192H117.278V177.248H116.784Z"
              fill="#1D1D1D"
            />
            <path
              d="M132.371 172.621H129.93H128.984H124.645H123.699H119.365H118.415H115.978C114.41 172.621 113.134 173.897 113.134 175.464V176.008C113.134 177.576 114.41 178.851 115.978 178.851H118.415H119.365H123.699H124.645H128.984H129.93H132.371C133.939 178.851 135.214 177.576 135.214 176.008V175.464C135.214 173.896 133.939 172.621 132.371 172.621ZM118.415 177.901H115.978C114.933 177.901 114.084 177.052 114.084 176.008V175.464C114.084 174.42 114.933 173.571 115.978 173.571H118.415V177.901ZM123.695 177.901H119.365V173.571H123.695V177.901ZM128.98 177.901H124.649V173.571H128.98V177.901ZM134.264 176.008C134.264 177.052 133.415 177.901 132.371 177.901H129.934V173.571H132.371C133.415 173.571 134.264 174.42 134.264 175.464V176.008Z"
              fill="#1D1D1D"
            />
            <path
              d="M159.118 177.444C158.677 177.706 157.522 178.242 158.226 178.913C158.569 179.24 158.952 179.474 159.434 179.474H162.181C162.662 179.474 163.045 179.24 163.389 178.913C164.093 178.242 162.937 177.706 162.497 177.444C161.463 176.828 160.152 176.828 159.118 177.444Z"
              stroke="#1D1D1D"
              strokeWidth={0.623051}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M162.21 174.646C162.21 175.42 161.583 176.048 160.808 176.048C160.034 176.048 159.406 175.42 159.406 174.646C159.406 173.872 160.034 173.244 160.808 173.244C161.583 173.244 162.21 173.872 162.21 174.646Z"
              stroke="#1D1D1D"
              strokeWidth={0.623051}
            />
            <path
              opacity={0.35}
              d="M159.742 162.615C159.742 162.272 160.02 161.994 160.363 161.994H165.14C165.483 161.994 165.761 162.272 165.761 162.615V164.335C165.761 164.678 165.483 164.956 165.14 164.956H160.363C160.02 164.956 159.742 164.678 159.742 164.335V162.615Z"
              stroke="black"
              strokeWidth={0.286603}
            />
            <path
              opacity={0.4}
              d="M166.191 162.902V164.048C166.422 163.951 166.572 163.725 166.572 163.475C166.572 163.225 166.422 162.999 166.191 162.902Z"
              fill="black"
            />
            <path
              d="M160.172 162.806C160.172 162.595 160.343 162.424 160.555 162.424H164.949C165.16 162.424 165.331 162.595 165.331 162.806V164.144C165.331 164.355 165.16 164.526 164.949 164.526H160.555C160.343 164.526 160.172 164.355 160.172 164.144V162.806Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M155.968 162.503C156.603 162.503 157.214 162.747 157.674 163.185C157.709 163.218 157.764 163.218 157.798 163.184L158.129 162.849C158.147 162.832 158.156 162.808 158.156 162.784C158.156 162.759 158.146 162.736 158.129 162.718C156.921 161.561 155.015 161.561 153.807 162.718C153.789 162.736 153.779 162.759 153.779 162.784C153.779 162.808 153.789 162.832 153.806 162.849L154.137 163.184C154.171 163.218 154.227 163.218 154.261 163.185C154.722 162.747 155.333 162.503 155.968 162.503ZM155.968 163.591C156.317 163.591 156.653 163.72 156.912 163.955C156.947 163.988 157.002 163.987 157.036 163.953L157.367 163.619C157.384 163.601 157.394 163.577 157.394 163.553C157.394 163.528 157.383 163.504 157.366 163.487C156.578 162.754 155.358 162.754 154.571 163.487C154.553 163.504 154.543 163.528 154.542 163.553C154.542 163.577 154.552 163.601 154.569 163.619L154.9 163.953C154.934 163.987 154.989 163.988 155.024 163.955C155.283 163.721 155.619 163.591 155.968 163.591ZM156.631 164.323C156.631 164.348 156.621 164.371 156.604 164.389L156.031 164.966C156.015 164.983 155.992 164.993 155.968 164.993C155.944 164.993 155.921 164.983 155.904 164.966L155.332 164.389C155.314 164.371 155.304 164.347 155.305 164.323C155.305 164.298 155.316 164.274 155.334 164.258C155.7 163.949 156.235 163.949 156.601 164.258C156.619 164.274 156.63 164.298 156.631 164.323Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M152.051 161.946H151.765C151.607 161.946 151.478 162.075 151.478 162.233V164.717C151.478 164.875 151.607 165.004 151.765 165.004H152.051C152.21 165.004 152.338 164.875 152.338 164.717V162.233C152.338 162.075 152.21 161.946 152.051 161.946ZM150.428 162.615H150.714C150.872 162.615 151.001 162.744 151.001 162.902V164.717C151.001 164.875 150.872 165.004 150.714 165.004H150.428C150.269 165.004 150.141 164.875 150.141 164.717V162.902C150.141 162.744 150.269 162.615 150.428 162.615ZM149.377 163.284H149.09C148.932 163.284 148.803 163.412 148.803 163.571V164.717C148.803 164.875 148.932 165.004 149.09 165.004H149.377C149.535 165.004 149.663 164.875 149.663 164.717V163.571C149.663 163.412 149.535 163.284 149.377 163.284ZM148.039 163.857H147.752C147.594 163.857 147.466 163.986 147.466 164.144V164.717C147.466 164.875 147.594 165.004 147.752 165.004H148.039C148.197 165.004 148.326 164.875 148.326 164.717V164.144C148.326 163.986 148.197 163.857 148.039 163.857Z"
              fill="black"
            />
            <path
              d="M73.9963 164.981C74.7667 164.981 75.2243 164.379 75.2243 163.359C75.2243 162.975 75.1508 162.651 75.0102 162.402C74.8066 162.013 74.456 161.803 74.0131 161.803C73.354 161.803 72.8879 162.246 72.8879 162.868C72.8879 163.451 73.3078 163.875 73.885 163.875C74.2398 163.875 74.5274 163.709 74.6701 163.422H74.6764C74.6764 163.422 74.6848 163.422 74.6869 163.422C74.6911 163.422 74.7058 163.422 74.7058 163.422C74.7058 164.114 74.4434 164.528 74.0005 164.528C73.7402 164.528 73.5387 164.385 73.4694 164.156H72.9299C73.0202 164.654 73.4421 164.981 73.9963 164.981ZM74.0152 163.445C73.6667 163.445 73.419 163.197 73.419 162.851C73.419 162.513 73.6793 162.255 74.0173 162.255C74.3552 162.255 74.6155 162.517 74.6155 162.859C74.6155 163.197 74.3615 163.445 74.0152 163.445Z"
              fill="black"
            />
            <path
              d="M76.1102 164.952C76.3096 164.952 76.4461 164.809 76.4461 164.62C76.4461 164.429 76.3096 164.289 76.1102 164.289C75.9129 164.289 75.7743 164.429 75.7743 164.62C75.7743 164.809 75.9129 164.952 76.1102 164.952ZM76.1102 163.378C76.3096 163.378 76.4461 163.237 76.4461 163.048C76.4461 162.857 76.3096 162.716 76.1102 162.716C75.9129 162.716 75.7743 162.857 75.7743 163.048C75.7743 163.237 75.9129 163.378 76.1102 163.378Z"
              fill="black"
            />
            <path
              d="M78.411 164.908H78.9295V164.343H79.3388V163.886H78.9295V161.879H78.1654C77.6301 162.685 77.204 163.359 76.9311 163.86V164.343H78.411V164.908ZM77.4328 163.867C77.7854 163.245 78.1003 162.748 78.39 162.32H78.4194V163.898H77.4328V163.867Z"
              fill="black"
            />
            <path
              d="M80.4934 164.908H81.035V161.879H80.4955L79.7041 162.433V162.954L80.4577 162.425H80.4934V164.908Z"
              fill="black"
            />
            <rect
              x={97.979}
              y={385.619}
              width={38.4049}
              height={1.43302}
              rx={0.716509}
              fill="black"
            />
          </g>
        </g>
        <rect
          x={63.4352}
          y={157.018}
          width={107.207}
          height={232.192}
          rx={3.09769}
          stroke="#EDEDED"
          strokeWidth={0.269364}
        />
      </g>
      <defs>
        <SvgShadowFilter id={"filter0_d_" + uniqueId} uniqueId={uniqueId} x={6.85464} y={12.472} width={452.29} height={312.081}
          radius={6.03054} dy={3.61832} blur={9.04581} />
        <SvgImagePattern id={"pattern0_" + uniqueId} uniqueId={uniqueId} transform="matrix(0.00133547 0 0 0.00160256 -0.000801428 0)" />
        <SvgShadowFilter id={"filter1_d_" + uniqueId} uniqueId={uniqueId} x={41.7514} y={138.567} width={150.575} height={275.56}
          radius={5.38728} dy={3.23237} blur={8.08092} composite />
        <SvgImagePattern id={"pattern1_" + uniqueId} uniqueId={uniqueId} transform="scale(0.00133346 0.00160256)" />
        <clipPath id={"clip0_" + uniqueId}>
          <rect
            x={30.9768}
            y={32.9758}
            width={404.046}
            height={263.836}
            rx={3.61832}
            fill="white"
          />
        </clipPath>
        <clipPath id={"clip1_" + uniqueId}>
          <rect
            x={287.277}
            y={76.3965}
            width={135.687}
            height={113.073}
            rx={2.71374}
            fill="white"
          />
        </clipPath>
        <clipPath id={"clip2_" + uniqueId}>
          <rect
            x={63.3005}
            y={156.883}
            width={107.476}
            height={232.461}
            rx={3.23237}
            fill="white"
          />
        </clipPath>
        <clipPath id={"clip3_" + uniqueId}>
          <rect
            width={107.476}
            height={232.453}
            fill="white"
            transform="translate(63.3003 156.883)"
          />
        </clipPath>
        <image
          id={"image0_" + uniqueId}
          ref={imageRef}
          width={750}
          height={624}
          href={isSafari ? src : ''}
          loading="lazy"
          />
      </defs>
    </svg>
  );
}
export const SvgTemplateMedium = React.memo(MediumTemplateSVG);